var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 145,
    viewBox: "0 0 169 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.1602 122.999L12.2363 74.5811L63.3481 45.0088L128.909 51.0807",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1 68.3517C1.57586 67.0918 12.3776 43.189 26.4948 35.0173C35.1152 30.0302 42.549 32.3225 47.1559 34.9823L58.5509 41.2992L18.6073 79.1307L6.84583 72.6213C3.37323 70.8015 1.2443 68.5792 1 68.3342V68.3517Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.7321 41.2471C23.6149 49.4188 12.8132 73.3216 12.2373 74.5815C12.8132 75.1765 23.7196 86.5154 37.8368 78.3437C51.9541 70.1719 62.7558 46.2516 63.3316 44.9917C62.7558 44.3968 51.8494 33.0578 37.7321 41.2296V41.2471Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M37.7512 46.0941C31.1725 49.8913 25.8676 59.1129 25.9025 66.6722C25.92 74.249 31.2597 77.2938 37.8385 73.4966C44.4172 69.6995 49.7221 60.4778 49.6872 52.901C49.6698 45.3417 44.33 42.297 37.7512 46.0941Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M37.7667 52.428C34.2243 54.4753 31.3799 59.4449 31.3799 63.5045C31.3799 67.5816 34.2592 69.2265 37.8016 67.1792C41.344 65.1319 44.1884 60.1623 44.1884 56.1027C44.1884 52.0256 41.3091 50.3982 37.7667 52.4455V52.428Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M112.541 103.627L89.2803 117.101V90.171V76.6973L112.541 103.627Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M89.2807 117.101L66.0195 103.627L89.2807 76.6973V90.171V117.101Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M31.4854 128.283C62.2501 146.692 112.559 147.427 143.848 129.911C175.136 112.395 175.555 83.2774 144.79 64.8516",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M16.3555 120.724C16.3555 125.151 17.1931 128.441 18.6589 131.573C20.0724 134.6 21.9919 137.278 24.4698 139.535C26.8605 141.722 29.5828 143.367 32.7587 144.102C35.6729 144.767 38.4998 144.609 41.1872 143.174C43.5255 141.915 45.1658 139.99 46.2478 137.592C47.3297 135.178 47.731 132.623 47.6089 129.998C47.3646 124.714 45.4625 120.024 42.2516 115.877C40.1227 113.112 37.5052 110.89 34.3292 109.42C32.2526 108.458 30.0888 107.88 27.7854 107.968C23.3356 108.143 20.1073 110.295 18.0481 114.232C16.8266 116.559 16.3555 119.062 16.3729 120.742L16.3555 120.724Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M41.1863 143.174C43.5246 141.914 45.1649 139.99 46.2469 137.592C47.3288 135.177 47.7301 132.623 47.608 129.998C47.3637 124.713 45.4616 120.024 42.2508 115.877C40.1218 113.112 37.5043 110.89 34.3283 109.42C32.2518 108.457 30.0879 107.88 27.7845 107.967C25.7603 108.055 24.0152 108.562 22.4971 109.437V109.402L32.9149 103.4H32.9323C34.4679 102.508 36.2479 102.001 38.2895 101.913C40.5755 101.826 42.7568 102.403 44.8334 103.365C48.0268 104.853 50.6269 107.058 52.7558 109.822C55.9667 113.969 57.8687 118.659 58.113 123.944C58.2352 126.568 57.8338 129.123 56.7519 131.538C55.7747 133.708 54.3263 135.44 52.337 136.7V136.752L41.1863 143.174Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M158.803 79.1997V52.2697L135.541 38.7959L112.28 52.2697V79.1997L135.541 92.6735L158.803 79.1997Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M158.802 79.1996L135.541 92.6733V65.7258L158.802 52.2695V79.1996Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M135.541 65.7259L112.28 79.1997V52.2697L135.541 38.7959V65.7259Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M135.541 92.6733L112.28 79.1996V52.2695L135.541 65.7258V92.6733Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M158.803 52.2697L135.541 65.7259L112.28 52.2697L135.541 38.7959L158.803 52.2697Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M158.803 41.4038V14.4738L135.541 1L112.28 14.4738V41.4038L135.541 54.8601L158.803 41.4038Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M158.802 41.4037L135.541 54.8599V27.9299L158.802 14.4736V41.4037Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M135.541 27.93L112.28 41.4038V14.4738L135.541 1V27.93Z",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M135.541 54.8599L112.28 41.4037V14.4736L135.541 27.9299V54.8599Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M125.629 43.5911L122.191 41.5962V37.6416L125.629 39.6189V43.5911Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M125.629 36.1548L122.191 34.1775V24.2559L125.629 26.2507V36.1548Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M158.803 14.4738L135.541 27.93L112.28 14.4738L135.541 1L158.803 14.4738Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.968cc71ff8a07dab9d6e697a249834a4.svg";
export { ForwardRef as ReactComponent };